import { useFs_Seedlings } from '@frontend/hooks/firestore/seedlings';
import { useFs_Review } from '@frontend/hooks/firestore/review';
import { useFs_Species } from '@frontend/hooks/firestore/species/index';

export namespace useFs {
  export import Seedlings = useFs_Seedlings;
  export import Review = useFs_Review;
  export import Species = useFs_Species;
}
